/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconRadiusBottomLeft = createReactComponent("outline", "radius-bottom-left", "IconRadiusBottomLeft", [["path", { "d": "M19 19h-6a8 8 0 0 1 -8 -8v-6", "key": "svg-0" }]]);

export { IconRadiusBottomLeft as default };
//# sourceMappingURL=IconRadiusBottomLeft.mjs.map
